<template>
  <div
    class="testimonials__card text-dark bg-white px-4 px-sm-5 py-4"
    v-if="testimonial"
  >
    <img
      :src="require(`@/assets/images/testimonials/${testimonial.imgName}`)"
      alt="testimonial image"
      class="testimonials__card__img"
    />
    <div class="testimonials__card__body mt-4 d-flex">
      <div class="ms-3">
        <p class="testimonials__card__desc mb-4">{{ testimonial.desc }}</p>
        <h3 class="testimonials__card__heading">{{ testimonial.name }}</h3>
        <small class="text-muted">{{ testimonial.title }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "testimonials-card",
  props: {
    testimonial: {
      type: Object,
      required: true,
    },
  },
};
</script>
